import { render, staticRenderFns } from "./uptime-chart.vue?vue&type=template&id=3296c7fc"
import script from "./uptime-chart.vue?vue&type=script&lang=js"
export * from "./uptime-chart.vue?vue&type=script&lang=js"
import style0 from "./uptime-chart.vue?vue&type=style&index=0&id=3296c7fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports